import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

// test

export const enum PageIdWoofz22V4 {
  SEX_22V4 = PageId.SEX_22V4,
  DOG_AGE_22V4 = PageId.DOG_AGE_22V4,
  DOG_BREED_22V4 = PageId.DOG_BREED_22V4,
  DOG_BREED_ID_22V4 = PageId.DOG_BREED_ID_22V4,
  URGE_22V4 = PageId.URGE_22V4,
  COMMANDS_61_22V4 = PageId.COMMANDS_61_22V4,
  COMMANDS_62_22V4 = PageId.COMMANDS_62_22V4,
  COMMANDS_63_22V4 = PageId.COMMANDS_63_22V4,
  URGE_2_22V4 = PageId.URGE_2_22V4,
  POTTY_22V4 = PageId.POTTY_22V4,
  BEHAVIOR_22V4 = PageId.BEHAVIOR_22V4,
  TRAINING_22V4 = PageId.TRAINING_22V4,
  PREPARE_FLOW_22V4 = PageId.PREPARE_FLOW_22V4,
  DOG_STATISTICS_22V4 = PageId.DOG_STATISTICS_22V4,
  EMAIL_22V4 = PageId.EMAIL_22V4,
  NEWSLETTER_URGE_22V4 = PageId.NEWSLETTER_URGE_22V4,
  LAST_CHANCE_OFFER_22V4 = PageId.LAST_CHANCE_OFFER_22V4,
  WELCOME_TO_WOOFZ_22V4 = PageId.WELCOME_TO_WOOFZ_22V4,
  SUBSCRIPTIONS_22V4 = PageId.SUBSCRIPTIONS_22V4,
  CANCEL_OFFER_22V4 = PageId.CANCEL_OFFER_22V4,
  CHAT_UPSELL_22V4 = PageId.CHAT_UPSELL_22V4,
  UPSELL_22V4 = PageId.UPSELL_22V4,
  ROVER_UPSELL_22V4 = PageId.ROVER_UPSELL_22V4,
  UPSELL_FEEDING_GUIDE_22V4 = PageId.UPSELL_FEEDING_GUIDE_22V4,
  UPSELL_EMOTIONAL_SUPPORT_22V4 = PageId.UPSELL_EMOTIONAL_SUPPORT_22V4,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_22V4 = PageId.DOWNLOAD_22V4,
}

type TIdToPageMapWoofz22V4 = Record<PageIdWoofz22V4, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ22V4: TIdToPageMapWoofz22V4 = {
  sex_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/SexQuesiton').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/SexQuesiton'),
  },
  dog_age_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/DogAgeQuestion'),
  },
  dog_breed_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  dog_breed_id_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/dog-breed/breedId/BreedPhotoScreen'
      ).then((m) => ({
        default: m.BreedPhotoScreen,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/dog-breed/breedId/BreedPhotoScreen'
      ),
  },
  urge_5_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4/pages/questions/UrgePage'),
  },
  commands_61_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/CommandsVariant61').then(
        (m) => ({
          default: m.CommandsVariant61,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/CommandsVariant61'),
  },
  commands_62_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/CommandsVariant62').then(
        (m) => ({
          default: m.CommandsVariant62,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/CommandsVariant62'),
  },
  commands_63_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/CommandsVariant63').then(
        (m) => ({
          default: m.CommandsVariant63,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/CommandsVariant63'),
  },
  urge_2_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/UrgePageVariant2'),
  },
  potty_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/PottyQuestion'),
  },
  behavior_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/BehaviorQuestion'),
  },
  training_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/questions/TrainingQuestion').then(
        (m) => ({
          default: m.TrainingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/TrainingQuestion'),
  },
  prepare_flow_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/prepare-flow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/prepare-flow/PrepareFlow'
      ),
  },
  dog_statistics_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/dog-statistics/DogStatistics'
      ).then((m) => ({
        default: m.DogStatistics,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/dog-statistics/DogStatistics'
      ),
  },
  email_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/email/Email22V4').then((m) => ({
        default: m.Email22V4,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4/pages/email/Email22V4'),
  },
  newsletter_urge_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/email/components/NewsletterUrge'),
  },
  last_chance_offer_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/last-chance-offer/LastChanceOfferPage'
      ).then((m) => ({
        default: m.LastChanceOfferPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4/pages/last-chance-offer/LastChanceOfferPage'
      ),
  },
  welcome_to_woofz_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/questions/abtest/WelcomeToWoofz'
      ).then((m) => ({
        default: m.WelcomeToWoofz,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/questions/abtest/WelcomeToWoofz'),
  },
  subscriptions_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/subscriptions/SubscriptionsPage'),
  },
  cancel_offer_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/subscriptions/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/subscriptions/CancelOffer'),
  },
  chat_upsell_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/upsell/ChatUpsellNewFlow'),
  },
  upsell_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4/pages/upsell/Upsell'),
  },
  upsell_feeding_guide_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/upsell/FeedingGuideUpsell'),
  },
  upsell_emotional_support_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/upsell/EmotionalSupportUpsell'),
  },
  account_nove8: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  rover_upsell_22v4: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4/abtest/rover-partnership2/RoverUpsellPage'
      ).then((m) => ({
        default: m.RoverUpsellPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4/abtest/rover-partnership2/RoverUpsellPage'
      ),
  },
  download_22v4: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4/pages/download-app/DownloadApp'),
  },
}
